module.exports = __webpack_public_path__ + "static/media/logger.5464da65.mp4";